import { createListPage } from 'pages/common/ListPage';
import { createTable } from 'pages/common/ListTable';

import { selectors, actions } from 'domain/item';
import { filterParams } from 'filters/item';

import { tableParams } from 'fields/item';

const { list: items, onInlineEdit: edit, loading, pagination } = selectors;
const { inlineEditAction: onEdit, updateItemAction } = actions;

const Table = createTable({
  tableName: 'itemList',
  tableParams,
  updateItemAction,
  allowEdit: () => false,
  connections: {
    items,
    edit,
    onEdit,
    loading,
    pagination,
  },
});

export default createListPage({
  name: 'Item',
  pagination,
  filterParams,
  Table,
  softDelete: false,
});
